import ServiceBase from '../ServiceBase';

export default class CommunicationService extends ServiceBase {
    constructor($http) {
        super($http);
    }

    getPledgeManagerReminderPreview(projectID) {
        return this.request('get', 'admin/communication/getPledgeManagerReminderPreview', { params: { projectID } });
    }

    sendPledgeManagerReminders(projectID) {
        return this.request('get', 'admin/communication/sendPledgeManagerReminders', { params: { projectID } });
    }

    validatePledgeManagerReminderCanBeSent(projectID) {
        return this.request('get', 'admin/communication/validatePledgeManagerReminderCanBeSent', { params: { projectID } });
    }

    getCommunicationSettings(projectID) {
        return this.request('get', 'admin/communication/getCommunicationSettings', { params: { projectID } });
    }

    updateCommunicationSettings(settings) {
        return this.request('post', 'admin/communication/updateCommunicationSettings', settings);
    }

    getCustomTermsOfService(projectID) {
        return this.request('get', 'admin/communication/getCustomTermsOfService', { params: { projectID } });
    }

    updateCustomTermsOfService(projectID, customTermsOfService) {
        return this.request('post', 'admin/communication/updateCustomTermsOfService', { projectID, customTermsOfService });
    }
}